import React, { useEffect, useState } from 'react'
import queryString from 'query-string'
import Logo from '../Logo'
import HeaderWrapper from './HeaderWrapper'
import { HeaderContainer, TeslaBrand, HeaderLinkWrapper } from './styles'
import { addMissingUtmTags } from '../../history'
import { useConfig } from 'hooks'
import { getCookie, CA_LOGGED_IN_COOKIE } from 'utils/cookie-helpers'
import config from 'config'
import { LinkButton } from 'components/@common/Button'

const Header = ({ affiliate, isLoading, campaignRef }) => {
  const [linkLogin, setLinkLogin] = useState(
    config.CUSTOMER_ACCOUNT_URL_NOT_LOGGED_IN,
  )
  const [isSignedIn, setIsSignedIn] = useState(false)
  const queries = addMissingUtmTags(new Object(null))
  const siteUrl = useConfig().SITE_URL
  const loggedInCookie = getCookie(CA_LOGGED_IN_COOKIE)

  const parsedQueryString = queryString.parse(window.location.search)

  useEffect(() => {
    let loginLink = ''
    if (loggedInCookie) {
      setIsSignedIn(JSON.parse(loggedInCookie))
      if (isSignedIn) {
        loginLink = config.CUSTOMER_ACCOUNT_URL
      } else {
        loginLink = config.CUSTOMER_ACCOUNT_URL_NOT_LOGGED_IN
      }
    } else {
      loginLink = config.CUSTOMER_ACCOUNT_URL_NOT_LOGGED_IN
    }

    if (parsedQueryString.affiliateId) {
      loginLink += '?affiliateId=' + parsedQueryString.affiliateId
    }

    setLinkLogin(loginLink)
  }, [loggedInCookie, isSignedIn, parsedQueryString])

  return (
    <HeaderWrapper>
      <HeaderContainer>
        <TeslaBrand>
          <Logo affiliate={affiliate} campaignRef={campaignRef} />
        </TeslaBrand>

        <HeaderLinkWrapper>
          <LinkButton
            href={queryString.stringifyUrl({
              url: `${siteUrl}/who-we-cover-eligibility`,
              query: { ...queries },
            })}
            target='_blank'
            id='eligibilityLnk'
            variant='line'
          >
            Eligibility
          </LinkButton>
        </HeaderLinkWrapper>
      </HeaderContainer>
    </HeaderWrapper>
  )
}

export default Header
